import { SortOptionType } from "Components/SortBar";
import { FormObjType } from "DataTypes/Form";
import DateTime from "Utils/DateTime";

export const AllergyForm: FormObjType[] = [
  {
    id: "substanceName",
    label: "Substance Name",
    placeholder: "Enter substance name",
    boxType: "input",
    boxSize: 3,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "startDate",
    label: "Start Date",
    placeholder: "Select start date",
    boxType: "date",
    boxSize: 3,
    validatetype: "date",
    enableFormLoad: true,
    maxVal: DateTime.CurrentDate(),
    dateType: "start"
  },
  {
    id: "endDate",
    label: "End Date",
    placeholder: "Select end date",
    boxType: "date",
    boxSize: 3,
    validatetype: "date",
    enableFormLoad: true,
    maxVal: DateTime.CurrentDate(),
    dateType: "stop"
  }
]

// The values are the search API's own sortBy values.
export const sortOptions: SortOptionType[] = [
  { label: "Name", value: "name" },
  { label: "Date", value: "date" },
];
